/**
 * change-password-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../../general/reply-message";
import { MessageTag } from "../../message-tag";

export class ChangePasswordRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_CHANGE_PASSWORD;
	public static tag : MessageTag = MessageTag.REQ_CHANGE_PASSWORD;

  constructor (public password : string, public currentPassword : string)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/credentials/change-password-request.ts